import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../config/api';
import { formatMatchDate } from '../../utils/matchDateTime';
import { FaArrowLeft, FaClipboardList, FaEye } from 'react-icons/fa';
import './AdminPages.css';

const AdminTicketParticipations = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [matches, setMatches] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const { data } = await api.get('/tickets/subscriber-participations');
        setMatches(data.matches || []);
      } catch (err) {
        console.error(err);
        alert('Erreur lors du chargement des participations');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const formatAdminDate = (d) => {
    if (!d) return '—';
    return new Date(d).toLocaleString('fr-CH', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="admin-page">
      <div className="admin-container">
        <div className="admin-page-header">
          <button
            type="button"
            className="btn-back"
            onClick={() => navigate('/admin')}
            style={{
              background: 'transparent',
              border: 'none',
              color: 'var(--juve-black)',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              fontSize: '1rem',
              marginBottom: '1rem',
            }}
          >
            <FaArrowLeft /> Retour au tableau de bord
          </button>
          <h1>
            <FaClipboardList style={{ marginRight: '0.5rem' }} />
            Participations des abonnés
          </h1>
        </div>

        <p style={{ marginBottom: '1.5rem', color: '#555' }}>
          Matchs Serie A à domicile pour lesquels une demande de participation a été envoyée aux abonnés.
        </p>

        {loading ? (
          <div className="loading">Chargement...</div>
        ) : (
          <div className="admin-table-container">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Match</th>
                  <th>Date</th>
                  <th>Envoyé le</th>
                  <th>Total</th>
                  <th>Réponses</th>
                  <th>En attente</th>
                  <th>Participent</th>
                  <th>Abo dispo</th>
                  <th>Gardent abo</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {matches.map((match) => {
                  const stats = match.stats || {};
                  return (
                    <tr key={match._id}>
                      <td>
                        <strong>{match.matchTitle}</strong>
                        <div style={{ fontSize: '0.85rem', color: '#666' }}>{match.stadium}</div>
                      </td>
                      <td>{formatMatchDate(match.date, 'fr-FR')}</td>
                      <td>{formatAdminDate(match.subscriberNotification?.sentAt)}</td>
                      <td>{stats.total ?? 0}</td>
                      <td>{stats.responded ?? 0}</td>
                      <td>{stats.pending ?? 0}</td>
                      <td>{stats.participate ?? 0}</td>
                      <td>{stats.available ?? 0}</td>
                      <td>{stats.keep ?? 0}</td>
                      <td className="actions">
                        <button
                          type="button"
                          className="btn-edit"
                          title="Voir les réponses"
                          onClick={() => navigate(`/admin/ticket-participations/${match._id}`)}
                        >
                          <FaEye />
                        </button>
                      </td>
                    </tr>
                  );
                })}
                {matches.length === 0 && (
                  <tr>
                    <td colSpan={10} style={{ textAlign: 'center', color: '#999' }}>
                      Aucune demande de participation envoyée pour le moment
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminTicketParticipations;
